import type { SVGProps } from "react";
import * as React from "react";

export const StarWideIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    className="fill-current"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={2}
      d="M7.546 1.633a.5.5 0 0 1 .908 0l1.686 3.655a.5.5 0 0 0 .395.287l3.997.474a.5.5 0 0 1 .28.864l-2.954 2.733a.5.5 0 0 0-.151.464l.784 3.948a.5.5 0 0 1-.735.534l-3.512-1.966a.5.5 0 0 0-.488 0l-3.512 1.966a.5.5 0 0 1-.735-.534l.784-3.948a.5.5 0 0 0-.15-.464L1.186 6.913a.5.5 0 0 1 .281-.864l3.997-.474a.5.5 0 0 0 .395-.287z"
    />
  </svg>
);
